/* KHAN sticky add-to-bag bar — slim, quiet, luxury.
   Appears after scrolling past the buy box on product pages. */
(function () {
  // Only on product pages with a product form
  var productForm = document.querySelector('product-form form, form[action*="/cart/add"]');
  if (!productForm) return;

  // Gather product info
  var titleEl = document.querySelector('.product__title');
  var priceEl = document.querySelector('.product .price');
  var imgEl = document.querySelector('.product__media img');
  if (!titleEl || !priceEl) return;

  var title = titleEl.textContent.trim();
  var price = priceEl.textContent.trim().replace(/\s+/g, ' ');
  var imgSrc = imgEl ? imgEl.src : '';
  var buyButton = productForm.querySelector('[name="add"], button[type="submit"]');

  // Build the bar
  var bar = document.createElement('div');
  bar.className = 'khan-sticky-atc';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML =
    (imgSrc ? '<img class="khan-sticky-atc__img" src="' + imgSrc + '" alt="">' : '') +
    '<div class="khan-sticky-atc__info">' +
    '<div class="khan-sticky-atc__title"></div>' +
    '<div class="khan-sticky-atc__price"></div>' +
    '</div>' +
    '<button type="button" class="button button--primary">Add to Bag</button>';
  bar.querySelector('.khan-sticky-atc__title').textContent = title;
  bar.querySelector('.khan-sticky-atc__price').textContent = price;
  document.body.appendChild(bar);

  // Clicking the bar's button triggers the real form
  bar.querySelector('.button').addEventListener('click', function () {
    if (buyButton) {
      buyButton.click();
    } else {
      productForm.requestSubmit();
    }
  });

  // Keep floating widgets (e.g. the Chatty chat bubble, bottom-right) clear of
  // the bar. We lift the bubble itself via inline style so this works even if
  // the widget's container id differs from our CSS guess.
  var chatBubble = null;
  function findChatBubble() {
    if (chatBubble && document.contains(chatBubble)) return chatBubble;
    var sels = '#chatty-app-display, [id^="chatty-app"], #chatty-root';
    var cands = document.querySelectorAll(sels);
    for (var i = 0; i < cands.length; i++) {
      var el = cands[i];
      if (el.tagName === 'STYLE' || el.tagName === 'SCRIPT') continue;
      if (el === bar || bar.contains(el)) continue;
      chatBubble = el;
      return el;
    }
    // Positional fallback: any small fixed element pinned to bottom-right.
    var all = document.body.querySelectorAll('*');
    for (var j = 0; j < all.length; j++) {
      var n = all[j];
      if (n === bar || bar.contains(n)) continue;
      var t = n.tagName;
      if (t === 'STYLE' || t === 'SCRIPT' || t === 'LINK' || t === 'META') continue;
      var cs;
      try { cs = getComputedStyle(n); } catch (e) { continue; }
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') continue;
      var r = n.getBoundingClientRect();
      if (r.width > 0 && r.width < 220 && r.height > 0 && r.height < 220 &&
          r.right >= window.innerWidth - 130 && r.bottom >= window.innerHeight - 130) {
        chatBubble = n;
        return n;
      }
    }
    return null;
  }
  function liftChat(show) {
    var bubble = findChatBubble();
    var h = bar.offsetHeight || 150;
    document.body.style.setProperty('--khan-sticky-atc-h', h + 'px');
    if (bubble) {
      bubble.style.transform = show ? 'translateY(' + (-h - 16) + 'px)' : '';
      bubble.style.transition = 'transform 0.45s cubic-bezier(0.22, 1, 0.36, 1)';
    }
  }

  // Show/hide based on buy-box visibility
  var buyBox = document.querySelector('.product-form__buttons') || productForm;
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          // Let floating widgets (e.g. the Chatty chat bubble) clear the bar:
          // body flag + measured bar height so CSS can lift them above it.
          document.body.classList.toggle('has-sticky-atc', show);
          if (show) {
            document.body.style.setProperty('--khan-sticky-atc-h', bar.offsetHeight + 'px');
          }
          liftChat(show);
        });
      },
      { threshold: 0 }
    );
    io.observe(buyBox);
  }

  // Keep price in sync if variant changes
  document.addEventListener('change', function () {
    setTimeout(function () {
      var p = document.querySelector('.product .price');
      if (p) {
        bar.querySelector('.khan-sticky-atc__price').textContent =
          p.textContent.trim().replace(/\s+/g, ' ');
      }
    }, 100);
  });
})();
